import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {Grid, Box, Typography, Paper ,Button, TableContainer, TableHead, TableRow, TableCell, TableBody, Tooltip} from "@mui/material";
import axios from "axios";
import ScheduleDemo from "./demo";
import { IconCloudDown, IconDownload, IconEye } from "@tabler/icons-react";
import { BeatLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { Card, Table } from "react-bootstrap";
import logo from '../Images/logo-dark.png'
import html2pdf from 'html2pdf.js';
import logospg from '../Images/LOGO_SPG.png'
import dayjs from "dayjs";
import Cookies from 'js-cookie';
const TransactionHistory = () => {
  const [transactions, settransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const userinfo = JSON.parse(Cookies.get("user-info"));
  const [loader,setLoader]= useState(false)
  const navigate = useNavigate()
  const [InvoiceData, setInvoiceData] = useState();
  const invoiceRef = useRef();
  
  const getData = async (page = 1, limit = 10) => {
    setLoader(true)
    try {
      const config2 = {
        headers: {
          Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`
        },
        params: {
          limit: limit,
          offset: (page-1)*10,
        }
      };
      const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/edit-payment/?customer_id=${userinfo.id}`, config2);
      if (response.status === 200) {
        settransactions(response.data.results);
        setTotalRows(response.data.count);
        setLoader(false)
      }
    } catch (err) {
      console.log(err);
      setLoader(false)
    }
  };
  
  useEffect(() => {
    getData()
  }, [])
  const getInvoiceData = async (Id) => {
    setLoader(true)
    try {
      const config2 = {
        headers: {
          Authorization:
            'gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ=='
        }
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL2}/apiV1/user-invoice/?user_id=${userinfo.id}&id=${Id}`,
        config2
      );
      if (response.status === 200) {
        setInvoiceData(response.data);
        setTimeout(() => {
          handleDownloadPDF();
          setLoader(false)
        }, 1000);
      }
    } catch (err) {
      console.log(err?.response?.data?.message);
          setLoader(false)

    }
  };
  const columns = [
     {
      name: "S.No",
      selector: (row,index) =>index + 1,
      // sortable: true,
    },
    {
      name: "Date of purchase",
      // selector: (row) => new Date(row.payment_date).toLocaleDateString("en-GB"),
      selector: (row) => row.payment_date ? dayjs(row.payment_date).format("MM-DD-YYYY") : "—",
      sortable: true,
    }
    ,
    {
      name: "Transaction ID",
      selector: (row) => row.transaction_id,
      sortable: true,
    },
    {
      name: "Plan Name",
      selector: (row) => row.subscription__plan__name,
      // sortable: true,
    },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currency,
    // },
    {
      name: "Amount",
      selector: (row) => row.amount_paid,
    },
    {
      name: "Payment Method",
      selector: (row) => row.payment_method,
    },
    {
      name: "Status",
      selector: (row) => row.payment_status,
      cell: (row) => (
        <Typography
          sx={{
            color: row.payment_status === "completed" ? "green" : row.payment_status === "pending" ? "orange" : "red",
            fontWeight: "bold",
          }}
        >
        {row.payment_status === "completed"? "Paid" : row.payment_status === "pending" ? "Pending": ""}
        </Typography>
      ),
    },
   {
  name: "Action",
  selector: (row) => row.payment_method,
  cell: (row) => (
    <Box sx={{ gap: 1, display: "flex" }}>
      <Tooltip title="View Invoice" arrow>
        <span
          style={{ color: "#096497", cursor: "pointer" }}
          onClick={() => navigate(`/plans/transactionhistory/invoice?id=${row.subscription_id}`)}
        >
          <IconEye />
        </span>
      </Tooltip>

      <Tooltip title="Download Invoice" arrow>
        <span
          style={{ color: "green", cursor: "pointer" }}
          onClick={() => getInvoiceData(row.subscription_id)}
        >
          <IconCloudDown />
        </span>
      </Tooltip>
    </Box>
  ),
}

  ];
  const handlePageChange = (page) => {
    setCurrentPage(page);
    getData(page, perPage);
  };
  
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    getData(page, newPerPage);
  };
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
  };
   const handleDownloadPDF = () => {
  setLoader(true);
  
  const element = invoiceRef.current;

  const opt = {
    margin: 0.5,
    filename: `Invoice-${InvoiceData?.invoice_number || 'Download'}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2,
      ignoreElements: (el) => el.classList?.contains("no-print")
    },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  };

  html2pdf()
    .set(opt)
    .from(element)
    .save()
    .then(() => {
      setLoader(false);
    })
    .catch(() => {
      setLoader(false);
    });
};

  return (
    <>
    <Box sx={{ padding: 3 }}>
       <ScheduleDemo showBanner={true} />
       {loader && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100vw",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        zIndex: 9999,
                    }}
                >
                    <BeatLoader color=" #07659c" size={20} />
                </Box>
            )}
      <Paper sx={{ padding: 3, boxShadow: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
          Transaction History
        </Typography>
        <DataTable
          columns={columns}
          data={transactions}
          pagination
          highlightOnHover
          responsive
          paginationServer
          fixedHeaderScrollHeight='600px'
          fixedHeader
          persistTableHead
          paginationTotalRows={totalRows}
          paginationComponentOptions={paginationComponentOptions}
          paginationPerPage={perPage}
          paginationDefaultPage={currentPage}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
        />
      </Paper>
    </Box>
    <Grid sx={{display:"none"}}>
    <Box  p={3} ref={invoiceRef} >
      <Card sx={{ p: 4}} >
         <Grid container spacing={2} alignItems="center" justifyContent="space-between" mb={2}>
          {/* Left: Company Info */}
          <Grid item xs={12} md={4}>
              <img src={logospg} alt="Logo" style={{ width: 120, maxWidth: '100%' }} /> 
            <Typography fontWeight={600}>
              {InvoiceData?.configuration__company_name}
            </Typography>
            <Box display="flex" gap={1} alignItems="start">
              {/* <LocationOn fontSize="small" color="action" /> */}
              <Box>
                <Typography variant="body2">{InvoiceData?.configuration__address_line_1}</Typography>
                <Typography variant="body2">{InvoiceData?.configuration__address_line_2}</Typography>
              </Box>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              {/* <Mail fontSize="small" color="action" /> */}
              <Typography variant="body2">
                {InvoiceData?.configuration__company_email}
              </Typography>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              {/* <Phone fontSize="small" color="action" /> */}
              <Typography variant="body2">{InvoiceData?.configuration__mobile_no}</Typography>
            </Box>
          </Grid>

          {/* Center: Logo */}
          <Grid item xs={12} md={4} textAlign="center">
            <Box mb={1}>
              <img src={logo} alt="Logo" style={{ width: 150, maxWidth: '100%' }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              Invoice
            </Typography>
          </Grid>

          {/* Right: Invoice Details */}
          <Grid item xs={12} md={4} textAlign={{ xs: 'left', md: 'right' }}>
            <Typography variant="body2">
              <strong>Invoice Number:</strong> {InvoiceData?.invoice_number}
            </Typography>
            <Typography variant="body2">
              <strong>Date:</strong>{" "}
              {InvoiceData?.date
                ? dayjs(InvoiceData.date).format("MM-DD-YYYY")
                : '--'}
            </Typography>
          </Grid>
        </Grid>
         <Box border="2px solid rgb(239, 239, 241)" borderRadius={1} p={2} mb={4}>
                  <Typography variant="h6" fontWeight={600} textAlign="center" mb={2}>
                    Customer Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2">Company Name :</Typography>
                      <Typography variant="body2">Contact Name :</Typography>
                      <Typography variant="body2">Email Id :</Typography>
                      <Typography variant="body2">Address :</Typography>
                      <Typography variant="body2">Phone :</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2">{InvoiceData?.customer__company_name || '—'}</Typography>
                      <Typography variant="body2">{InvoiceData?.customer__full_name || '—'}</Typography>
                      <Typography variant="body2">{InvoiceData?.customer__corp_email || '—'}</Typography>
                      <Typography variant="body2">
                        {(InvoiceData?.customer_add_info?.[0]?.address_line_1 || '—') +
                          (InvoiceData?.customer_add_info?.[0]?.city ? `, ${InvoiceData.customer_add_info[0].city}` : '') +
                          (InvoiceData?.customer_add_info?.[0]?.postal_code ? `, ${InvoiceData.customer_add_info[0].postal_code}` : '')}
                      </Typography>
                      <Typography variant="body2">{InvoiceData?.customer_add_info?.[0]?.phone_number || '—'}</Typography>
                    </Grid>
                  </Grid>
                </Box>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#004466' }}>
                <TableCell sx={{ color: '#fff' }}>S.NO</TableCell>
                <TableCell sx={{ color: '#fff' }}>PLAN TYPE</TableCell>
                <TableCell sx={{ color: '#fff' }}>DESCRIPTION</TableCell>
                <TableCell sx={{ color: '#fff' }} align="center">QUANTITY</TableCell>
                <TableCell sx={{ color: '#fff' }} align="center">UNIT PRICE</TableCell>
                <TableCell sx={{ color: '#fff' }} align="right">PRICE</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Line Item Row */}
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>{InvoiceData?.billing_info?.[0]?.item_name}</TableCell>
                <TableCell>A Plan with {InvoiceData?.billing_info?.[0]?.no_of_projects_allowed} projects</TableCell>
                <TableCell align="center">{InvoiceData?.billing_info?.[0]?.no_of_projects_allowed}</TableCell>
                <TableCell align="center">{(InvoiceData?.billing_info?.[0]?.actual_amount / InvoiceData?.billing_info?.[0]?.no_of_projects_allowed).toFixed(2)}</TableCell>
                <TableCell align="right">${InvoiceData?.billing_info?.[0]?.actual_amount}</TableCell>
              </TableRow>

              {/* Tax Row */}
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>Tax({InvoiceData?.tax_info?.tax_percent}%)</TableCell>
                <TableCell>-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="right">${InvoiceData?.tax_info?.tax_price}</TableCell>
              </TableRow>
              {InvoiceData?.is_promo_code === true && <TableRow>
                <TableCell>3</TableCell>
                <TableCell>Discount({InvoiceData?.billing_info[0]?.promo_discount_value}%)</TableCell>
                <TableCell>-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="right">${InvoiceData?.billing_info[0]?.sub_promo_discount_amount}</TableCell>
              </TableRow>
  }

              {/* Grand Total Row */}
              <TableRow>
                <TableCell>-</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Grand Total</TableCell>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell align="right" sx={{ fontWeight: 600 }}>
                  ${InvoiceData?.total_amount}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

    <Box textAlign="center" bgcolor="primary.lighter" borderRadius={2} >
            <Typography variant="h6" color="primary.dark" gutterBottom>
                Thank You for Your Purchase!
            </Typography>
        </Box>
       
      </Card>
    </Box>
    </Grid>
    </>
  );
};

export default TransactionHistory;
